import React from "react";
import homekit from "../../../../content/blogs/Homekit/image.png";
export default {
  React,
  homekit
};